import OrderInfoGrid from './OrderInfo';

const OrderDetailsSection = ({ type, orderDetails }) => (
  <>
    {type !== 'DetailsFailedTransactions' && type !== 'DetailsVinculationOrders' && (
      <OrderInfoGrid
        title={
          type === 'detailsHistoryPrepaid'
            ? 'Detalles del Producto'
            : type === 'detailsSimIpb'
              ? 'Detalles del Producto'
              : 'Beneficiario'
        }
        type={type}
        orderDetails={orderDetails}
      />
    )}
  </>
);

export default OrderDetailsSection;
